/******************************************************************************
 *** BgtOvrlDpstViewDialog ** 총괄 조합비 * 수입결의서 상세정보 모달
*******************************************************************************/
import AppContext from "@/js/common/AppContext";
import Axios from "@/js/common/Axios";
import { budgetFilesProps } from "@/js/common/types/types";
import Util from "@/js/common/Util";
import React from "react";
import BudgetViewFile from "../../budgetFileBox/BudgetViewFile";
import Button from "@/js/common/ui/Button";
import DatePickerBox from "@/js/common/ui/input/DatePickerBox";
import SelectBox from "@/js/common/ui/input/SelectBox";
import TextBox from "@/js/common/ui/input/TextBox";
import NumberTextBox from "@/js/common/ui/input/NumberTextBox";
import AtrzLineBox from "./AtrzLineBox";  


interface Props {
    ovrlMbsdsDpstDocId: string;
    setOvrlDpstModalOpen: Function;
}
const BgtOvrlDpstViewDialog = ( {ovrlMbsdsDpstDocId, setOvrlDpstModalOpen}: Props ) => {
    const [dpstRsdocNo      , setDpstRsdocNo      ] = React.useState<string>(""); // 결의서 문서번호
    const [orgCd            , setOrgCd            ] = React.useState<string>(""); // 조직코드
    const [dpstDt           , setDpstDt           ] = React.useState<string>(""); // 수입일자 (YYYYMMDD)
    const [bgtSbjct1stCd    , setBgtSbjct1stCd    ] = React.useState<string>(""); // 1차 코드(관)
    const [bgtSbjct2stCd    , setBgtSbjct2stCd    ] = React.useState<string>(""); // 2차 코드(항)
    const [bgtSbjct3stCd    , setBgtSbjct3stCd    ] = React.useState<string>(""); // 3차 코드(목)
    const [abstrCn          , setAbstrCn          ] = React.useState<string>(""); // 적요
    const [memo             , setMemo             ] = React.useState<string>(""); // 메모
    const [dpstAmt          , setDpstAmt          ] = React.useState<string>(""); // 수입 금액
    const [atrzSttsCd       , setAtrzSttsCd       ] = React.useState<string>(""); // 결재상태정보
    // const [atrzSttsNm       , setAtrzSttsNm       ] = React.useState<string>(""); // 결재상태정보
    const [atrzOpnnCn       , setAtrzOpnnCn       ] = React.useState<string>(""); // 반려사유(결재의견)

    const [savedDpstFiles, setSavedDpstFiles] = React.useState<budgetFilesProps[]>([]); // 저장된 파일
    const [listLine, setListLine] = React.useState<any[]>([]);  // 결재 라인 정보
    const [openLine, setOpenLine] = React.useState<boolean>(false); // 기본 펼침/접힘


    // 특별회계기금 수입결의서 상세정보 조회
    React.useEffect(() => {
        AppContext.showSpinner();
        Axios.dataAccess({
            url: "system/bgt/ovrl/whol/select-ovrl-whol-dpst-dtl.do",   // 전체 조회
            methodType: "post",
            paramType: "json",
            paramData: {
                ovrlMbsdsDpstDocId: ovrlMbsdsDpstDocId   // 수입결의서 문서 ID
            },
            onSuccessFn: (res: any) => {
                if (Util.isNotEmpty(res.result.item)) {
                    setDpstRsdocNo  (res.result.item.dpstRsdocNo  ); // 문서번호
                    setOrgCd        (res.result.item.orgCd        ); // 조직코드
                    setDpstDt       (res.result.item.dpstDt       ); // 수입일자
                    setBgtSbjct1stCd(res.result.item.bgtSbjct1stCd); // 1차 코드(관)
                    setBgtSbjct2stCd(res.result.item.bgtSbjct2stCd); // 2차 코드(항)
                    setBgtSbjct3stCd(res.result.item.bgtSbjct3stCd); // 3차 코드(목)
                    setAbstrCn      (res.result.item.abstrCn      ); // 적요
                    setMemo         (res.result.item.memo         ); // 메모
                    setDpstAmt      (res.result.item.dpstAmt      ); // 수입금액
                    // setAtrzSttsNm   (res.result.item.atrzSttsNm   ); // 결재진행상태
                    setAtrzOpnnCn   (res.result.item.atrzOpnnCn   ); // 반려사유(결재의견)
                    setAtrzSttsCd   (res.result.item.atrzSttsCd   ); // 결재상태정보
                    setListLine(res.result.listLine || []);

                    setSavedDpstFiles(res.result.listFile); // 첨부파일
                }
                AppContext.hideSpinner();
            },
        });
    }, [ovrlMbsdsDpstDocId]);

    return (
        <div className="w100p dpFlx jcC">
            <div className="dpFlx aiFs pt10">
                <div className="w480">
                    <div className="bd1d9d9d9 bdrd6 bgcWhite">
                        <div className="p15">
                            <div className="mb10 dpFlx jcSb">
                                <div>
                                    <span className="fm-b fs16 fc007bff ls1 fw700">수입결의서 상세내용</span>
                                    <span className="fm-b fs13 ls06 fc616EEA ml10">[{Util.getValToCode("ATRZ_STTS_CD", atrzSttsCd)}]</span>
                                </div>
                                <div>
                                    <span className="fm-b fs13 ls06 fc777777 mr10">{dpstRsdocNo}</span>
                                </div>
                            </div>

                            {["03", "04", "05"].includes(atrzSttsCd) && (
                            <AtrzLineBox
                                listLine={listLine}
                                open={openLine}
                                onToggle={() => setOpenLine((v) => !v)}
                            />
                            )}

                            <div className="dpFlx mb5">
                                {/* 수입일자 */}
                                <div className="dpFlx flxdCol flx1">
                                    <div className="h30 dpFlx aiE pb5">
                                        <span className="fm-b fs13 ls06 fc111111">수입일자</span>
                                    </div>
                                    <DatePickerBox value={dpstDt}
                                        width={200} height={36}
                                        fontSize={14} fontFamily="fm-c" color="#333" letterSpacing={-1}
                                        borderColor="#ddd" borderOnColor="#222" borderRadius={2}
                                        bgColor={"#F6F6F6"}
                                        textAlign="left"
                                        calendarThemeColor={AppContext.themeColor}
                                        onChange={(data: string) => setDpstDt(data)}
                                        disabled={true}
                                    />
                                </div>

                                {/* 금액 */}
                                <div className="dpFlx flxdCol flx1">
                                    <div className="h30 dpFlx aiE pb5">
                                        <span className="fm-b fs13 ls06 fc111111">금액</span>
                                    </div>
                                    <div className="w220 h36 dpFlx aiC bsBdb">
                                        <NumberTextBox value={dpstAmt}
                                            className="w220 h36 bd1 bdrd2 bgcFFE6CE"
                                            thousandsGroupStyle="thousand" thousandSeparator=","
                                            placeholder="0"
                                            fontSize={14} fontFamily="fm-c" letterSpacing={-1}
                                            onChange={(data: string) => setDpstAmt(data)}
                                            inputClass={"taR mr5"}
                                            disabled={true}
                                        />
                                    </div>

                                </div>
                            </div>

                            {/* 관/항/목 */}
                            <div className="dpFlx mb5">
                                {/* 관 */}
                                <div className="dpFlx flxdCol flx1">
                                    <div className="h30 dpFlx aiE pb5">
                                        <span className="fm-b fs13 ls06 fc111111">관</span>
                                    </div>
                                    <SelectBox value={bgtSbjct1stCd}
                                        width={140} height={36}
                                        fontSize={14} fontFamily="fm-c" color="#333" letterSpacing={-1}
                                        borderColor="#ddd" borderOnColor="#222" borderRadius={2}
                                        background="#F6F6F6" paddingRight={8}
                                        codeArray={[{ code: "", name: "선택" }].concat(Util.getBgt1CodeArray("01", orgCd))}
                                        placeholder="선택"
                                        onChangeFunc={(data: string) => setBgtSbjct1stCd(data)}
                                        disabled={true}
                                    />
                                </div>

                                {/* 항 */}
                                <div className="dpFlx flxdCol flx1">
                                    <div className="h30 dpFlx aiE pb5">
                                        <span className="fm-b fs13 ls06 fc111111">항</span>
                                    </div>
                                    <SelectBox value={bgtSbjct2stCd}
                                        width={140} height={36}
                                        fontSize={14} fontFamily="fm-c" color="#333" letterSpacing={-1}
                                        borderColor="#ddd" borderOnColor="#222" borderRadius={2}
                                        background="#F6F6F6" paddingRight={8}
                                        codeArray={[{ code: "", name: "선택" }].concat(Util.getBgt2CodeArray(bgtSbjct1stCd, orgCd))}
                                        placeholder="선택"
                                        onChangeFunc={(data: string) => setBgtSbjct2stCd(data)}
                                        disabled={true}
                                    />
                                </div>

                                {/* 목 */}
                                <div className="dpFlx flxdCol flx1">
                                    <div className="h30 dpFlx aiE pb5">
                                        <span className="fm-b fs13 ls06 fc111111">목</span>
                                    </div>
                                    <SelectBox value={bgtSbjct3stCd}
                                        width={142} height={36}
                                        fontSize={14} fontFamily="fm-c" color="#333" letterSpacing={-1}
                                        borderColor="#ddd" borderOnColor="#222" borderRadius={2}
                                        background="#F6F6F6" paddingRight={8}
                                        codeArray={[{ code: "", name: "선택" }].concat(Util.getBgt3CodeArray(bgtSbjct2stCd, orgCd))}
                                        placeholder="선택"
                                        onChangeFunc={(data: string) => setBgtSbjct3stCd(data)}
                                        disabled={true}
                                    />
                                </div>
                            </div>

                            {/* 적요 */}
                            <div className="dpFlx flxdCol mb5">
                                <div className="h30 dpFlx aiE pb5">
                                    <span className="fm-b fs13 ls06 fc111111">적요</span>
                                </div>
                                <TextBox value={abstrCn}
                                    width={454} height={36}
                                    fontSize={14} fontFamily="fm-c" color="#333" letterSpacing={-1}
                                    borderColor="#ddd" borderOnColor="#222" borderRadius={2}
                                    style={{ backgroundColor: "#F6F6F6", padding: "0 12px" }}
                                    onChangeFunc={(t: string) => setAbstrCn(t)}
                                    mode={"disabled"}
                                />
                            </div>

                            {/* 메모 */}
                            <div className="dpFlx flxdCol mb5">
                                <div className="h30 dpFlx aiE pb5">
                                    <span className="fm-b fs13 ls06 fc111111">메모</span>
                                </div>
                                <TextBox value={memo}
                                    width={454} height={36}
                                    fontSize={14} fontFamily="fm-c" color="#333" letterSpacing={-1}
                                    borderColor="#ddd" borderOnColor="#222" borderRadius={2}
                                    style={{ backgroundColor: "#F6F6F6", padding: "0 12px" }}
                                    onChangeFunc={(t: string) => setMemo(t)}
                                    mode={"disabled"}
                                />
                            </div>

                            <BudgetViewFile
                                fileSeCd="C01"              // 파일구분코드(총괄 수입결의서[C01])
                                savedBudgetFiles   ={savedDpstFiles}
                                width = "450px"
                                height = "70px"
                            />

                            {/* 반려 */}
                            {atrzSttsCd === "05" &&
                                <div className="dpFlx flxdCol">
                                    <div className="h30 dpFlx aiE pb5">
                                        <span className="fm-b fs13 ls06 fc111111">반려</span>
                                    </div>
                                    <div className="dpFlx aiFs">
                                        <div className="flxg1 bsBdb">
                                            <textarea
                                                value={atrzOpnnCn}
                                                className="h70 bsBdb p10 bd1 bdcDFDFDF bdrd2 fm-c fs13 fc333333 ls1 bgcF6F6F6 rszN"
                                                style={{width: "452px"}}
                                                maxLength={2000}
                                                placeholder=""
                                                onChange={(e) => setAtrzOpnnCn(e.target.value)}
                                                readOnly={true}
                                            />
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                    {/* 닫기 버튼 */}
                    <div className="dpFlx jcC pt20 pb20">
                        <Button buttonName="닫기"
                            width={110} height={42}
                            fontFamily="fm-b" fontSize={16} letterSpacing={-1}
                            variant="styCloseBtn" borderRadius={5}
                            buttonClass="dpFlx aiC jcC"
                            onClickFunc={() => setOvrlDpstModalOpen(false)}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BgtOvrlDpstViewDialog;